import { render, staticRenderFns } from "./PostFilesArea.vue?vue&type=template&id=5b31c933&scoped=true&"
import script from "./PostFilesArea.vue?vue&type=script&lang=ts&"
export * from "./PostFilesArea.vue?vue&type=script&lang=ts&"
import style0 from "./PostFilesArea.vue?vue&type=style&index=0&id=5b31c933&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31c933",
  null
  
)

export default component.exports